export const PIN_FILE = 'dt/user-settings/PIN_FILE';
export const PERSIST_PIN_FILE = 'dt/user-settings/PERSIST_PIN_FILE';
export const REMOVE_PINNED_FILE = 'dt/user-settings/REMOVE_PINNED_FILE';
export const BOOKMARK_CREATED = 'dt/user-settings/BOOKMARK_CREATED';
export const BOOKMARK_DELETED = 'dt/user-settings/BOOKMARK_DELETED';

export const pinFile = (fileId) => ({
  type: PIN_FILE,
  fileId,
});

export const removePinnedFile = (fileId) => ({
  type: REMOVE_PINNED_FILE,
  fileId,
});

export const bookmarkCreated = (fileId, bookmark) => ({
  type: BOOKMARK_CREATED,
  fileId,
  bookmark,
});

export const bookmarkDeleted = (fileId, id) => ({
  type: BOOKMARK_DELETED,
  fileId,
  id,
});
